import { Eshop } from './getEshops';
import Image from 'next/image';
import { EshopTable } from '../EshopTable';
import { MarkdownContent } from '@/components/Markdown/Markdown';

export function getSectionsForEshop(eshop: Eshop): Array<{
	title: string;
	content: string | JSX.Element;
}> {
	const sections = [];

	if (eshop.contentArea1?.content) {
		sections.push({
			title: eshop.contentArea1.title,
			content: (
				<div className="text-lg lg:text-xl">
					<MarkdownContent content={eshop.contentArea1.content} listVariant="grid" />
				</div>
			),
		});
	}

	if (eshop.contentArea2?.content) {
		sections.push({
			title: eshop.contentArea2.title,
			content: (
				<div>
					<MarkdownContent content={eshop.contentArea2.content} listVariant="grid" />
					{eshop.contentImage1?.asset?.url && (
						<Image
							className="my-10 overflow-hidden rounded-2xl lg:my-16"
							src={eshop.contentImage1.asset.url}
							alt="alt"
							width={768}
							height={432}
						/>
					)}
				</div>
			),
		});
	}

	if (eshop.contentArea3?.content) {
		sections.push({
			title: eshop.contentArea3.title,
			content: (
				<>
					<MarkdownContent content={eshop.contentArea3.content} listVariant="grid" />
					{eshop.contentTable1 && <EshopTable rows={eshop.contentTable1.rows} />}
					{eshop.contentImage2?.asset?.url && (
						<Image
							className="my-10 overflow-hidden rounded-2xl lg:my-16"
							src={eshop.contentImage2.asset.url}
							alt="alt"
							width={768}
							height={432}
						/>
					)}
				</>
			),
		});
	}

	if (eshop.contentArea4?.content) {
		sections.push({
			title: eshop.contentArea4.title,
			content: (
				<>
					<MarkdownContent content={eshop.contentArea4.content} listVariant="grid" />
					{eshop.contentImage3?.asset?.url && (
						<Image
							className="my-10 overflow-hidden rounded-2xl lg:my-16"
							src={eshop.contentImage3.asset.url}
							alt="alt"
							width={768}
							height={432}
						/>
					)}
				</>
			),
		});
	}

	if (eshop.contentArea5?.content) {
		sections.push({
			title: eshop.contentArea5.title,
			content: <MarkdownContent content={eshop.contentArea5.content} listVariant="grid" />,
		});
	}

	return sections;
}
